import {GuestTaxExemption, NONE_EXEMPTION} from '@chekin/core';

const ChildrenExemptionsIDs = {
  childWithSpecialNeeds: '4',
};

class TaxGuestListEntity {
  list: GuestTaxExemption[];

  constructor(guestTaxesList: GuestTaxExemption[] = []) {
    this.list = [...guestTaxesList];
  }

  private findIndexById(id?: string | null) {
    if (!id) return -1;
    return this.list.findIndex(guest => guest.id === id || guest.guest_id === id);
  }

  private updateAt(index: number, data: Partial<GuestTaxExemption>) {
    if (index === -1) return this;
    this.list = this.list.map((guest, i) => (i === index ? {...guest, ...data} : guest));
    return this;
  }

  public checkIfExistById(id?: string) {
    return this.findIndexById(id) !== -1;
  }

  public checkIfExemptionExistsByGuestId(id?: string) {
    if (!id) return false;
    return !!this.list.find(
      item => item.guest_id === id && item.exemption !== NONE_EXEMPTION,
    );
  }

  public updateOne(id: string, data: Partial<GuestTaxExemption>) {
    return this.updateAt(this.findIndexById(id), data);
  }

  public addExemption(data: GuestTaxExemption) {
    const listWithoutExemptions = this.list.filter(
      guest => !guest.exemption || guest.exemption === NONE_EXEMPTION,
    );
    const childrenExemptionsIdsList = Object.values(ChildrenExemptionsIDs);

    if (this.checkIfExistById(data.id)) {
      this.updateOne(data.id, data);
    } else if (listWithoutExemptions.length) {
      const exemption = data.exemption ?? '';
      const isExemptionForChildren = childrenExemptionsIdsList.includes(exemption);
      const sortedListByAges = listWithoutExemptions.sort((a, b) => {
        return isExemptionForChildren ? b.age + a.age : b.age - a.age;
      });

      this.updateAt(this.list.indexOf(sortedListByAges[0]), {
        exemption: data.exemption,
        guest_id: data.guest_id,
      });
    }

    return this;
  }

  public removeExemption(id: string) {
    return this.updateOne(id, {exemption: null, guest_id: ''});
  }

  public exec() {
    return this.list;
  }
}

export default TaxGuestListEntity;
